{
  "labelsRacun": {
    "opozorilo": "Clicking 'Delete' will deactivate your account. Once deactivated, you will no longer be able to log in to or use the WingSI program.",
    "potrdiIzbris": "Are you sure you want to delete/deactivate your account? Once deactivated, you will no longer be able to log in to or use the WingSI program.",
    "potrjenIzbris": "User account successfully deleted/deactivated. You will be logged out of the application in a few seconds.",
    "napakaIzbrisa": "An error occurred while deleting the account. Please contact the airport administrator.",
    "napakaPilota": "We were unable to find a connection to the pilot for the currently logged-in user. Please contact the airport manager.",
    "buttons": {
      "odpri": "Proceed with deletion/deactivation",
      "izbrisi": "Delete"
    }
  }
}